var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKlicklySpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  className: "klickly-spinner_svg__lds-spinner",
  preserveAspectRatio: "xMidYMid",
  style: {
    backgroundImage: "none",
    backgroundPosition: "initial initial",
    backgroundRepeat: "initial initial"
  },
  viewBox: "0 0 100 100"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 15,
  x: 47,
  y: 15.5,
  fill: "currentColor",
  rx: 12.22,
  ry: 4.03
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.8099999999999999s",
  dur: "0.9s",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 15,
  x: 47,
  y: 15.5,
  fill: "currentColor",
  rx: 12.22,
  ry: 4.03,
  transform: "rotate(36 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.72s",
  dur: "0.9s",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 15,
  x: 47,
  y: 15.5,
  fill: "currentColor",
  rx: 12.22,
  ry: 4.03,
  transform: "rotate(72 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.63s",
  dur: "0.9s",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 15,
  x: 47,
  y: 15.5,
  fill: "currentColor",
  rx: 12.22,
  ry: 4.03,
  transform: "rotate(108 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.54s",
  dur: "0.9s",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 15,
  x: 47,
  y: 15.5,
  fill: "currentColor",
  rx: 12.22,
  ry: 4.03,
  transform: "rotate(144 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.45s",
  dur: "0.9s",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 15,
  x: 47,
  y: 15.5,
  fill: "currentColor",
  rx: 12.22,
  ry: 4.03,
  transform: "rotate(180 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.36s",
  dur: "0.9s",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 15,
  x: 47,
  y: 15.5,
  fill: "currentColor",
  rx: 12.22,
  ry: 4.03,
  transform: "rotate(216 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.27s",
  dur: "0.9s",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 15,
  x: 47,
  y: 15.5,
  fill: "currentColor",
  rx: 12.22,
  ry: 4.03,
  transform: "rotate(252 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.18s",
  dur: "0.9s",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 15,
  x: 47,
  y: 15.5,
  fill: "currentColor",
  rx: 12.22,
  ry: 4.03,
  transform: "rotate(288 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.09s",
  dur: "0.9s",
  repeatCount: "indefinite",
  values: "1;0"
}))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 15,
  x: 47,
  y: 15.5,
  fill: "currentColor",
  rx: 12.22,
  ry: 4.03,
  transform: "rotate(324 50 50)"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0s",
  dur: "0.9s",
  repeatCount: "indefinite",
  values: "1;0"
}))));
export default SvgKlicklySpinner;